const productRoute = window.location.pathname.match(/products-v2/) ? 'products-v2' : 'products'

export default {
  checkout: 'checkout-v2',
  checkoutRegistration: 'registration',
  checkoutShipping: 'shipping',
  checkoutPayment: 'payment',
  checkoutConfirmation: 'confirmation',
  pageNotFound: 'page-not-found',
  product: productRoute,
  demo: 'demo',
  demoForm: 'demo-form',
  demoSizing: 'demo-sizing',
}
